export const formatPrice = (price) => {
  if (!price) return '0.00';

  // console.log('formatPrice called with price:', price);

  const num = Number(String(price).replace(/[^0-9.]/g, ''));

  // return num.toLocaleString('en-IN', {
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });

  return num;
};
